import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';

import Capabilities from './pages/Capabilities';
import PageNotFound from './pages/404Page';
import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';


function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Acklod | Cloud Consulting Services");

  return (
    <>
      <Router>
      
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/capabilities" element={<Capabilities />} /> 
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<PageNotFound />} />
            
          </Routes>
        </ScrollToTop>
        
      </Router>
    </>
  );
}


export default App;
